import { ENGAGEMENT_TYPE_COLOR_MAP } from 'dashboard409a/pages/Workboard/common/constants';

export const getEngagementTypeColor = (engagementType: string): string =>
  ENGAGEMENT_TYPE_COLOR_MAP[engagementType as keyof typeof ENGAGEMENT_TYPE_COLOR_MAP] || '#000000';

export const toSolidColor = (color: string): string => {
  if (!color) {
    return '#000000';
  }

  if (color.length === 9 && color.startsWith('#')) {
    return color.slice(0, 7);
  }

  if (color.startsWith('rgba')) {
    const matches = /rgba?\((\d+),\s*(\d+),\s*(\d+)/.exec(color);
    if (matches) {
      const r = Number.parseInt(matches[1], 10).toString(16).padStart(2, '0');
      const g = Number.parseInt(matches[2], 10).toString(16).padStart(2, '0');
      const b = Number.parseInt(matches[3], 10).toString(16).padStart(2, '0');
      return `#${r}${g}${b}`;
    }
  }

  return color;
};
